<template>
  <div id="app">
    <router-view v-show="!loading" />
    <div class="load" v-show="loading">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "App",
  data() {
    return {
      loading: true
    };
  },
  beforeCreate() {
    this.loading = true;
  },
  created() {
    this.loading = true;
  },

  mounted() {
    document.getElementById("preloader").style.display = "none";
    var that = this;
    this.$nextTick(() => {
      // 确保dom异步加载完毕
      that.loading = false;
    });
  },
  methods: {
    onloadimg() {}
  }
};
</script>

<style>
body{
  font-size: 14px;
}
html,body{
  -webkit-overflow-scrolling:touch
}
a{
  cursor: pointer ;
}
/* loading */
.spinner {
  margin: 30% auto;
  width: 50px;
  height: 60px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #67cf22;
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}
.main {
  max-width: 1200px;
}
/* 子元素都是横向的  子div都往左边靠 纵向剧中 */

.flex_row_start {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  flex-direction: row;
  -webkit-flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是横向的  子div都往右边靠 纵向剧中 */

.flex_row_end {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  flex-direction: row;
  -webkit-flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是横向的  子div都往中间靠 纵向剧中 */

.flex_row_center {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是横向的  子div都往中间靠 纵向剧中 */

.flex_row_between {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  flex-direction: row;
  -webkit-flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是横向的  子div都均分 纵向剧中 */

.flex_row_around {
  display: flex;
  display: -webkit-flex;
  justify-content: space-around;
  -webkit-justify-content: space-around;
  flex-direction: row;
  -webkit-flex-direction: row;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是横向的  子div都往左边靠 */

.flex_row_line {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  flex-direction: row;
  -webkit-flex-direction: row;
}

/* 子元素都是纵向的  子div都往上边靠 横向居中 */

.flex_column_start {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是纵向的  子div都往下边靠 横向居中 */

.flex_column_end {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是纵向的  子div都往左靠 横向居中 */

.flex_column_center-left {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: stretch;
  -webkit-align-items: stretch;
}

/* 子元素都是纵向的  子div都往上下靠 横向居中 */

.flex_column_space-between {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
}

/* 子元素都是纵向的  子div都往中间靠 横向居中 */

.flex_column_center {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue